module.exports = __webpack_public_path__ + "static/media/visa.2d8c67c3.svg";